module.exports = __webpack_public_path__ + "img/salesProductCode.2e255f87.png";